"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTheme = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = require("styled-components");
var helpers_1 = require("./helpers");
var ThemeProvider = function (_a) {
    var theme = _a.theme, dark = _a.dark, breakpoint = _a.breakpoint, children = _a.children;
    var fulfilledTheme = (0, react_1.useMemo)(function () {
        var themedBreakpoints = theme.breakpoints, supportedBreakpoints = theme.supportedBreakpoints, heuristicBreakpoints = theme.heuristicBreakpoints, themedPalette = theme.palette, colors = theme.colors, themedDarkDefaults = theme.darkDefaults, restTheme = __rest(theme, ["breakpoints", "supportedBreakpoints", "heuristicBreakpoints", "palette", "colors", "darkDefaults"]);
        var darkDefaults = __assign(__assign({}, Object.keys(colors).reduce(function (acc, color) {
            var _a;
            return (__assign(__assign({}, acc), (_a = {}, _a[color] = color, _a)));
        }, {})), themedDarkDefaults);
        var reversedColorNames = Object.keys(colors).reduce(function (acc, color) {
            var _a;
            return (__assign(__assign({}, acc), (_a = {}, _a[colors[color]] = color, _a)));
        }, {});
        return __assign({ breakpoints: (0, helpers_1.getBreakpoints)(supportedBreakpoints, themedBreakpoints), supportedBreakpoints: supportedBreakpoints, heuristicBreakpoints: heuristicBreakpoints, palette: (0, helpers_1.getPalette)(themedPalette, colors, darkDefaults), colors: colors, darkDefaults: darkDefaults, reversedColorNames: reversedColorNames }, restTheme);
    }, [theme]);
    var currentTheme = (0, react_1.useMemo)(function () {
        var breakpoints = fulfilledTheme.breakpoints, supportedBreakpoints = fulfilledTheme.supportedBreakpoints, heuristicBreakpoints = fulfilledTheme.heuristicBreakpoints, palette = fulfilledTheme.palette, colors = fulfilledTheme.colors, darkDefaults = fulfilledTheme.darkDefaults, reversedColorNames = fulfilledTheme.reversedColorNames, restTheme = __rest(fulfilledTheme, ["breakpoints", "supportedBreakpoints", "heuristicBreakpoints", "palette", "colors", "darkDefaults", "reversedColorNames"]);
        return __assign(__assign(__assign({}, breakpoints[breakpoint]), { supportedBreakpoints: supportedBreakpoints, heuristicBreakpoints: heuristicBreakpoints, palette: palette[dark ? 'dark' : 'light'], colors: colors, darkDefaults: darkDefaults, reversedColorNames: reversedColorNames, dark: dark }), restTheme);
    }, [fulfilledTheme, dark, breakpoint]);
    return react_1.default.createElement(styled_components_1.ThemeProvider, { theme: currentTheme }, children);
};
var useTheme = function () { return (0, react_1.useContext)(styled_components_1.ThemeContext); };
exports.useTheme = useTheme;
exports.default = ThemeProvider;
